import { ApiResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { DiseaseDto, DiseaseForUpdateDto } from '../dtos/Event';
import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import api from '@/utils/httpClient';

export interface UpdateDiseaseForEventParameters {
	diseaseId: string;
	data: DiseaseForUpdateDto;
}

async function updateDisease(diseaseId: string, data: DiseaseForUpdateDto) {
  const config: any = { containsPHI: false };
  return api
    .put(`/api/diseases/${diseaseId}`, data, config)
    .then((response) => (response.data as ApiResponse<DiseaseDto>).data);
}

function useUpdateDisease(
  options?: UseMutationOptions<DiseaseDto, AxiosError, UpdateDiseaseForEventParameters>
) {
  return useMutation(
    async ({ diseaseId, data }: UpdateDiseaseForEventParameters) => updateDisease(diseaseId, data),
    options
  );
}

async function deleteDisease(diseaseId: string) {
  return api.delete(`/api/diseases/${diseaseId}`).then(() => {});
}

export { useUpdateDisease, updateDisease, deleteDisease };
